import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Loader2, Upload } from 'lucide-react';
import { runAiJob } from '../../lib/aiJob';

export const ImportDocumentDialog = ({ matter, open, onOpenChange, onUpdated }) => {
  const { api } = useAuth();
  const [file, setFile] = useState(null);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async () => {
    if (!file && text.trim().length < 40) return toast.error('Sube un archivo o pega el texto del documento');
    const form = new FormData();
    if (file) form.append('file', file);
    else form.append('text', text);
    setBusy(true);
    try {
      const r = await runAiJob(api, `/crm/matters/${matter.id}/import-document`, form);
      setResult(r);
      setFile(null);
      setText('');
      toast.success(r.message);
      onUpdated();
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message || 'No se pudo analizar el documento');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="import-document-dialog" className="bg-slate-900 border-slate-700 text-white max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-white">Importar documento judicial</DialogTitle>
          <DialogDescription className="text-slate-400">
            Sube la resolución, el estado diario o el ebook descargado de la Oficina Judicial Virtual. La IA vincula la causa y agenda la audiencia si la hay.
          </DialogDescription>
        </DialogHeader>
        <label className="flex items-center gap-2 border border-dashed border-slate-600 rounded-lg p-3 cursor-pointer hover:border-amber-500 text-sm text-slate-300">
          <Upload className="w-4 h-4" />{file ? file.name : 'Elegir PDF, DOCX o TXT'}
          <input data-testid="import-document-file" type="file" accept=".pdf,.docx,.txt" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} />
        </label>
        {!file && (
          <textarea data-testid="import-document-text" value={text} onChange={(e) => setText(e.target.value)} rows={5} placeholder="...o pega aquí el texto de la resolución" className="w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 text-sm text-white" />
        )}
        <button data-testid="import-document-submit" onClick={submit} disabled={busy} className="w-full bg-amber-500 text-slate-950 font-semibold py-2 rounded-lg flex items-center justify-center gap-2 disabled:opacity-50">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />}{busy ? 'Analizando...' : 'Analizar e importar'}
        </button>
        {result && (
          <div data-testid="import-document-result" className="text-sm bg-slate-800/60 rounded-lg p-3 space-y-1">
            <p className="text-white font-medium">{result.message}</p>
            {result.resumen && <p className="text-slate-300">{result.resumen}</p>}
            {(result.plazos || []).map((p, i) => <p key={i} className="text-amber-300">• {p}</p>)}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
